import React from 'react';

import Text from '../../shared/Typography';
import Floater from '../../shared/Floater';

/* eslint-disable */
class Playground extends React.Component {

  render() {
    return (
      <React.Fragment>
        <Text h2 className='pattern-library__section-title'>Playground!</Text>
        <hr />
        <Text h3 className='pattern-library__section-title'>Floater!</Text>
        <Floater title='this is a title' text='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.' footer='this is a footer'>
          Click to see a tooltip!
        </Floater>
        <Text h3 className='pattern-library__section-title'>Signature Pad!</Text>
      </React.Fragment>
    );
  }
};

export default Playground;
/* eslint-enable */


// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/playground.js